module.exports = __webpack_public_path__ + "static/img/pass_ocb.b316e5c4.svg";